import { FileItem, FileStatus } from '@spendbrain/types/files';
import { create } from 'zustand';

export interface FileUploadStore {
  onFilesUploaded: (() => void) | null;
  setOnFilesUploaded: (onFilesUploaded: (() => void) | null) => void;
  files: FileItem[];
  getFiles: () => FileItem[];
  setFiles: (files: FileItem[]) => void;
  addFiles: (newFiles: FileItem[]) => void;
  updateFile: (updatedFile: FileItem) => void;
  removeFile: (fileId: string) => void;
  selectAll: (selected: boolean) => void;
  deleteSelectedFiles: () => void;
  removeUploadedFiles: () => void;
  resetFiles: () => void;
  getAreFilesUploading: () => boolean;
}

export const createFileUploadStore = () =>
  create<FileUploadStore>((set, get) => ({
    onFilesUploaded: null,
    setOnFilesUploaded: onFilesUploaded => set({ onFilesUploaded }),
    files: [],
    getFiles: () => get().files,
    setFiles: files => set({ files }),
    addFiles: newFiles =>
      set(state => ({ files: [...state.files, ...newFiles] })),
    updateFile: updatedFile =>
      set(state => ({
        files: state.files.map(file =>
          file.id === updatedFile.id ? updatedFile : file
        ),
      })),
    removeFile: fileId =>
      set(state => ({
        files: state.files.filter(file => file.id !== fileId),
      })),
    selectAll: selected =>
      set(state => ({
        files: state.files.map(file => ({ ...file, selected })),
      })),
    deleteSelectedFiles: () =>
      set(state => ({
        files: state.files.filter(file => !file.selected),
      })),
    removeUploadedFiles: () =>
      set(state => ({
        files: state.files.filter(file => file.status !== FileStatus.Uploaded),
      })),
    resetFiles: () => set({ files: [] }),
    getAreFilesUploading: () =>
      get().files.some(file => file.status === FileStatus.Uploading),
  }));

export const useTicketFileUploadStore = createFileUploadStore();

export const useFileManagerFileUploadStore = createFileUploadStore();
